import * as React from "react"
import type { SVGProps } from "react"
const SvgAddressBook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5.5 23a1 1 0 0 1-.71-.29A1 1 0 0 1 4.5 22q0-.42.29-.71A1 1 0 0 1 5.5 21h14q.42 0 .71.29.3.29.29.71c-.01.42-.1.52-.29.71a1 1 0 0 1-.71.29zm0-20a1 1 0 0 1-.71-.29A1 1 0 0 1 4.5 2q0-.42.29-.71A1 1 0 0 1 5.5 1h14q.42 0 .71.29.3.29.29.71c-.01.42-.1.52-.29.71a1 1 0 0 1-.71.29zm7 10q1.25 0 2.13-.87A3 3 0 0 0 15.5 10q0-1.25-.87-2.12A3 3 0 0 0 12.5 7q-1.25 0-2.12.88A3 3 0 0 0 9.5 10q0 1.25.88 2.13a3 3 0 0 0 2.12.87m-8 7q-.82 0-1.41-.59A2 2 0 0 1 2.5 18V6q0-.82.59-1.41A2 2 0 0 1 4.5 4h16q.83 0 1.41.59.6.59.59 1.41v12q0 .83-.59 1.41a2 2 0 0 1-1.41.59zm1.75-2a8 8 0 0 1 2.73-2.2q1.6-.8 3.52-.8c1.92 0 2.46.27 3.53.8a8 8 0 0 1 2.72 2.2h1.75V6h-16v12zm2.95 0h6.6a6 6 0 0 0-1.56-.75A6 6 0 0 0 12.5 17q-.9 0-1.74.25A6 6 0 0 0 9.2 18m3.3-7a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.42.29-.71A1 1 0 0 1 12.5 9a.97.97 0 0 1 1 1q0 .42-.29.71a1 1 0 0 1-.71.29" />
  </svg>
)
export default SvgAddressBook
